import "./styles/App.scss";

import React from "react";
import Header from "./Header";

import {
  // BrowserRouter as Router,
  HashRouter as Router,
  Switch,
  Route,
  // Redirect,
} from "react-router-dom";
import NewNotification from "./NewNotification";
import Notifications from "./Notifications";
import Recipients from "./Recipients";
import Auth from "./Auth";
import { isAuthenticated } from "../utils/auth-utils";
// import ResponseSubmission from "./ResponseSubmission";
import Statistics from "./Statistics";

const DEBUG = false;

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <>
          <Header showNavigation={false} />
          <Component {...props} />;
        </>
      );
    }}
  />
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!DEBUG && !isAuthenticated()) {
        return <Auth/>
        // return <Redirect to="/login" />;
        // props.history.push("/login")
      } else {
        return (
          <>
            <Header showNavigation={true} />
            <Component {...props} />
          </>
        );
      }
    }}
  />
);

function App() {
  return (
    <Router>

      <Switch>
        <PublicRoute exact path="/login" component={Auth} />
        {/* <PublicRoute
          exact
          path="/rsp/:phoneNr"
          component={ResponseSubmission}
        /> */}
        <PrivateRoute exact path="/notifications" component={Notifications} />
        <PrivateRoute exact path="/recipients" component={Recipients} />
        <PrivateRoute exact path="/statistics" component={Statistics} />
        <PrivateRoute exact path="/" component={NewNotification} />
      </Switch>
    </Router>
  );
}

export default App;
